import React from 'react';

import JobField from '../../../JobField';
import JobAttributeLabel from '../JobAttributeLabel';
import JobAttributeValue from '../JobAttributeValue';

interface Props {
    schemaAttributeId: number;
    documentSetId: number;
}

export default function JobAttribute(props: Props): React.ReactElement {
    const { schemaAttributeId, documentSetId } = props;

    return (
        <JobField
            label={
                <JobAttributeLabel
                    schemaAttributeId={schemaAttributeId}
                    documentSetId={documentSetId}
                />
            }
            value={
                <JobAttributeValue
                    schemaAttributeId={schemaAttributeId}
                    documentSetId={documentSetId}
                />
            }
        />
    );
}
